import React from "react";
import { Title } from "../../atoms";

export const AppFooter = () => {
    return (
        <div className="appFooter">
            <Title text="Co-founded with Nova" className="footerText" />
        </div>
    );
};
